// extracted by mini-css-extract-plugin
export default {"root":"juUpou","resetDesignAttributes":"HrGJHc","bg":"QWERyM","css-background":"I7xYyx","cssBackground":"I7xYyx"};